import axios from './axiosConfig';
import { Contact, CreateContactDTO, UpdateContactDTO } from '../types/contact.types';

// List contacts for a client (optionally including archived)
export const getClientContacts = async (clientId: string, includeArchived = false): Promise<Contact[]> => {
  const response = await axios.get<{ data: Contact[] }>('/contacts', {
    params: { clientId, includeArchived: includeArchived ? 'true' : undefined },
  });
  return response.data.data || [];
};

export const getContact = async (id: string): Promise<Contact> => {
  const response = await axios.get<{ data: Contact }>(`/contacts/${id}`);
  return response.data.data;
};

export const createContact = async (data: CreateContactDTO): Promise<Contact> => {
  const response = await axios.post<{ data: Contact }>('/contacts', data);
  return response.data.data;
};

export const updateContact = async (id: string, data: UpdateContactDTO): Promise<Contact> => {
  const response = await axios.put<{ data: Contact }>(`/contacts/${id}`, data);
  return response.data.data;
};

// Archive requires a replacement PRIMARY when archiving the sole primary and
// other active contacts exist (server-enforced).
export const archiveContact = async (id: string, promoteContactId?: string): Promise<Contact> => {
  const response = await axios.post<{ data: Contact }>(`/contacts/${id}/archive`, { promoteContactId });
  return response.data.data;
};

export const unarchiveContact = async (id: string): Promise<Contact> => {
  const response = await axios.post<{ data: Contact }>(`/contacts/${id}/unarchive`);
  return response.data.data;
};

export const deleteContact = async (id: string): Promise<void> => {
  await axios.delete(`/contacts/${id}`);
};
